<script setup>
  import { onMounted, computed } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import { useUserStore } from '@/stores/userStore'

  const router = useRouter()
  const route = useRoute()
  const userStore = useUserStore()

  // URLパラメータからtypeを取得
  const registrationType = computed(() => route.query.type)

  // typeに応じた文言を計算
  const messageContent = computed(() => {
    if (registrationType.value === 'invitation') {
      return {
        title: 'ユーザー追加が完了しました',
        showTrialInfo: false,
        message: 'アカウントが追加されました。ログインしてご利用ください。',
      }
    } else {
      return {
        title: '登録が完了しました',
        showTrialInfo: true,
        message: '',
      }
    }
  })

  onMounted(async () => {})
  // ログイン画面へ移動
  const goToLogin = () => {
    router.push('/login')
  }
</script>

<style lang="less" scoped>
  .complete-main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    color: var(--text-color);
  }

  .message-content {
    width: 100%;
    max-width: 600px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    text-align: center;
  }
  .title {
    margin-bottom: 20px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 20px 0;
  }

  .content {
    text-align: center;
    line-height: 1.5;
  }

  .header {
    margin-bottom: 30px;
  }

  .content-message {
    font-size: 14px;
    margin-bottom: 30px;
    text-align: center;
    line-height: 1.6;
    color: #333;
  }

  .action-buttons {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
  }
</style>

<template>
  <main class="complete-main">
    <div class="complete-container">
      <h1><img class="logo" src="@/assets/img/login_logo.svg" alt="ディーモ for 社労士" /></h1>
      <div class="message-content">
        <p class="title">{{ messageContent.title }}</p>

        <!-- 招待ユーザーの場合のシンプルなメッセージ -->
        <div v-if="!messageContent.showTrialInfo" class="header">
          <div class="content-message" v-html="messageContent.message"></div>
        </div>

        <!-- 新規登録ユーザーの場合のトライアル情報 -->
        <div v-if="messageContent.showTrialInfo" class="trial-info">
          <h3>
            ディーモfor社労士は60日間のトライアル期間を
            <br />
            提供しています。
          </h3>
          <p>
            トライアル期間中は、制限なく
            <br />
            すべての機能をご利用いただけます。
          </p>
          <p>有料プランへの変更はいつでも可能です。</p>
        </div>

        <div class="action-buttons">
          <button class="input-submit" @click="goToLogin">ログインへ</button>
        </div>
      </div>
    </div>
  </main>
</template>
